import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

const POWERBI_BASE = 'https://app.powerbi.com/view?r=';
// REPLACE THIS with the home’s publish-to-web report token (the `r=` value only).
const WEEKLY_MENU_REPORT_ID =
  'eyJrIjoiNjk4NzU2YzUtMmVhOS00NmFlLTk5MGItOWQ0ZWIxNDdkOTdjIiwidCI6ImUzNmQ3NWZhLWU4NjItNDAyMC05MzllLTU0YjFiNDQ2NGFlMSJ9';
const weeklyMenuSrc = `${POWERBI_BASE}${WEEKLY_MENU_REPORT_ID}&navContentPaneEnabled=false&filterPaneEnabled=false`;

function WeeklyMenus() {
  return (
    <>
      <Helmet>
        <title>Our Food | Whitstable House</title>
        <meta
          name="description"
          content="View the weekly menus at Whitstable House."
        />
        <link rel="canonical" href="https://www.whitstable.house/weekly-menus/" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section weekly-menus-page">
            <div className="weekly-menus-container">
              <h1>Our Food</h1>
              <section className="food-report">
                <div className="food-report__frame">
                  <iframe
                    title="Whitstable House Food Dashboard Weekly Menu"
                    src={weeklyMenuSrc}
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              </section>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Whitstable House <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Whitstable House, Boorman Way, Whitstable CT5 3SE</p>
                <p>Copyright © Whitstable House</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default WeeklyMenus;
